var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitBedroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9688 8.33366V5.83366C16.9688 4.91699 16.2188 4.16699 15.3021 4.16699H5.30208C4.38542 4.16699 3.63542 4.91699 3.63542 5.83366V8.33366C2.71875 8.33366 1.96875 9.08366 1.96875 10.0003V14.167H3.07708L3.63542 15.8337H4.46875L5.02708 14.167H15.5854L16.1354 15.8337H16.9688L17.5271 14.167H18.6354V10.0003C18.6354 9.08366 17.8854 8.33366 16.9688 8.33366ZM9.46875 8.33366H5.30208V5.83366H9.46875V8.33366ZM15.3021 8.33366H11.1354V5.83366H15.3021V8.33366Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitBedroom);
export default __webpack_public_path__ + "static/media/unitBedroom.fcb69be3b814241cb5895e0c605d62f7.svg";
export { ForwardRef as ReactComponent };